import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import { Expaned } from '@/components/layout/layout'
import './stock-join.scss'
import StockJoinTable from './stock-join-table/stock-join-table'
import { DatePicker } from 'antd'

const StockSearch = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('stock-join', e, m)
    const [date, setDate] = useState<string[]>([])

    return (
        <>
            <Expaned className={getCls()}>
                <div className={getCls('header')}>
                    <div
                        className="time-picker"
                        style={{
                            marginLeft: '16px',
                        }}
                    >
                        <DatePicker.RangePicker
                            dateRender={current => (
                                <div
                                    className="ant-picker-cell-inner"
                                    style={{
                                        borderRadius: '50%',
                                    }}
                                >
                                    {current.date()}
                                </div>
                            )}
                            onChange={(monent, dateString) => {
                                setDate(dateString)
                            }}
                            suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                        />
                    </div>
                </div>
                <Expaned data-row className={getCls('content')}>
                    <StockJoinTable date={date} />
                </Expaned>
            </Expaned>
        </>
    )
}

export default StockSearch
